import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./theme.css";
import App from "./App";

const savedTheme = localStorage.getItem("kademy-theme");
if (savedTheme === "dark") {
  document.documentElement.setAttribute("data-theme", "dark");
}

// Render App first
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ----------------------
// DYNAMIC SCRIPT LOADER
// ----------------------
function loadScript(src, attrs = {}) {
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = src;
    s.async = false;
    Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
    s.onload = () => resolve(src);
    s.onerror = (e) => reject(new Error(`Failed to load ${src}`));
    document.body.appendChild(s);
  });
}

async function loadThemeScripts() {
  try {
    await loadScript(`${process.env.PUBLIC_URL}/assets/js/jquery-3.7.1.min.js`);
    await loadScript(`${process.env.PUBLIC_URL}/assets/js/imagesloaded.pkgd.min.js`);
    await loadScript(`${process.env.PUBLIC_URL}/assets/js/jquery.magnific-popup.min.js`);
    await loadScript(`${process.env.PUBLIC_URL}/assets/js/isotope.pkgd.min.js`);
    await loadScript(`${process.env.PUBLIC_URL}/assets/js/jquery.appear.min.js`);
    await loadScript(`${process.env.PUBLIC_URL}/assets/js/jquery.easing.min.js`);
    await loadScript(`${process.env.PUBLIC_URL}/assets/js/owl.carousel.min.js`);
    await loadScript(`${process.env.PUBLIC_URL}/assets/js/counter-up.js`);
    await loadScript(`${process.env.PUBLIC_URL}/assets/js/jquery.nice-select.min.js`);
    await loadScript(`${process.env.PUBLIC_URL}/assets/js/wow.min.js`);
    await loadScript(`${process.env.PUBLIC_URL}/assets/js/bootstrap.bundle.min.js`);
    await loadScript(`${process.env.PUBLIC_URL}/assets/js/main.js`);
    document.querySelector(".preloader")?.classList.add("hide");


    console.log("Theme scripts loaded successfully");
  } catch (err) {
    console.error("Error loading theme scripts:", err);
  }
}

loadThemeScripts();
